import EquipmentSection from "./EquipementSection";

export default EquipmentSection;
